import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
// core components
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import styles from "assets/jss/material-kit-react/components/dialogConfirmacao.js";

import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

function renderMsg(msg) {
    return msg;
}

export default function Confirmacao(props) {
  const classes = useStyles();
  const { className, showAlert, onClose, btnNaoText, btnSimText, callbackYes, callbackNo, title, msg, ...rest } = props;
  return (
    <div {...rest}>
        <Dialog
            open={showAlert}
            onClose={() => {onClose()}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
            <DialogContentText id="alert-dialog-description" style={{display: 'flex', flexDirection: 'column'}}>
                    <HelpOutlineOutlinedIcon style={{ margin: 'auto', marginBottom: '10px', fontSize: '40px', color:"#03a1fc", }} />
                    <text style={{ margin: 'auto', marginBottom: '10px', fontSize: '20px', fontWeight: '500' }}>Confirmação</text>
                    <div style={{whiteSpace: 'pre-wrap', textAlign: 'center', minWidth: '225px'}}>{msg}</div>
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{display: 'flex', marginBottom: '10px'}}>
                <Button onClick={() => callbackYes()} color="primary" style={{backgroundColor: '#03a1fc', margin: 'auto', marginRight: '10px'}}>
                    {(btnSimText) ? btnSimText : 'Sim'}
                </Button>
                <Button color="primary" style={{backgroundColor: '#03a1fc', margin: 'auto', marginLeft: '10px'}} onClick={() => {
                        callbackNo();
                    }}>
                    {(btnNaoText) ? btnNaoText : 'Não'}
                </Button>
            </DialogActions>
        </Dialog>
    </div>
  );
}

Confirmacao.propTypes = {
  className: PropTypes.string,
};